

//product section tab js
document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".tab");
  const contents = document.querySelectorAll(".tab-content");

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      // Remove active class from all tabs and contents
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(content => content.classList.remove("active"));

      // Add active class to clicked tab and corresponding content
      tab.classList.add("active");
      const target = document.querySelector(tab.dataset.target);
      target.classList.add("active");
    });
  });
});


// ScrollHint
  window.addEventListener('DOMContentLoaded', function () {
    new ScrollHint('.feature-container',{
      scrollHintIconAppendClass: 'scroll-hint-icon-white', 
      suggestiveShadow: true
    });
    

    new ScrollHint('.area-collection-container',{
      scrollHintIconAppendClass: 'scroll-hint-icon-white', 
      suggestiveShadow: true
    });


    
  });

// window.addEventListener('DOMContentLoaded', function () {
//     const selectors = ['.feature-container', '.how-to', '.area-collection'];

//     selectors.forEach(selector => {
//         new ScrollHint(selector, {
//             scrollHintIconAppendClass: 'scroll-hint-icon-white', 
//             suggestiveShadow: true
//         });
//     });
// });
